import React from "react";
import { BlogAreaThreeItem } from "./BlogAreaThreeItem";
import { getBlogs } from "../../data/blogs";
import { useTranslation } from "react-i18next";

export const BlogAreaThree = () => {
  const { t } = useTranslation();
  const blogs = getBlogs(t);

  return (
    <section className="blog-area-three pt-120 pb-90">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section-title-two text-center mb-50 tg-heading-subheading animation-style1">
              <span className="sub-title tg-element-title">
                {t("home.blogSubTitle")}
              </span>
              <h2 className="title tg-element-title">
                {t("home.blogTitle")}
              </h2>
              <p>{t("home.blogText")}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {blogs.map((blog) => (
            <div key={blog.id} className="col-lg-4 col-md-6 col-sm-10">
              <BlogAreaThreeItem blog={blog} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
